import { PriceRange, ProductVariantSize } from '../interfaces/ProductVariant'

export function findMatchingRange(
  ranges: PriceRange[] | undefined,
  quantity: number
): PriceRange | undefined {
  if (!ranges?.length) return undefined
  return ranges.find(
    range =>
      quantity >= range.min_quantity &&
      (range.max_quantity === null || quantity <= range.max_quantity)
  )
}

export function resolveUnitPrice(
  sizeObj: Pick<ProductVariantSize, 'price' | 'price_ranges'> | undefined | null,
  quantity: number,
  bulkPricingEnabled: boolean,
  fallbackPrice: number
): number {
  if (!sizeObj) return fallbackPrice

  if (bulkPricingEnabled) {
    const range = findMatchingRange(sizeObj.price_ranges, quantity)
    if (range) return range.price
  }

  return sizeObj.price && sizeObj.price > 0 ? sizeObj.price : fallbackPrice
}

export function priceForQuantity(
  item: Pick<
    import('../interfaces/Product').Product,
    'price' | 'bulk_pricing_enabled' | 'price_ranges'
  >,
  quantity: number
): number {
  if (!item.bulk_pricing_enabled || !item.price_ranges?.length) {
    return item.price
  }
  return resolveUnitPrice(
    { price: item.price, price_ranges: item.price_ranges },
    quantity,
    true,
    item.price
  )
}

export function sortPriceRanges(ranges: PriceRange[]): PriceRange[] {
  return [...ranges].sort((a, b) => a.min_quantity - b.min_quantity)
}

export function formatRangeLabel(min: number, max: number | null): string {
  return max === null ? `${min}+` : `${min} – ${max}`
}
